import { CardNetwork, ThaiBank } from "@boo/shared";
import { siAmericanexpress, siJcb, siMastercard, siVisa } from "simple-icons";

type LogoBank = Exclude<ThaiBank, ThaiBank.None>;

interface BankLogoInfo {
  label: string;
  /** File in public/logos/banks (thai-banks-logo, ISC). */
  file: string;
  color: string;
}

// KTC (Krungthai Card) has no logo of its own in the set; it shares KTB's.
export const BANK_LOGOS: Record<LogoBank, BankLogoInfo> = {
  [ThaiBank.Kbank]: {
    label: "Kasikornbank",
    file: "KBANK.png",
    color: "#1DA858",
  },
  [ThaiBank.Scb]: { label: "SCB", file: "SCB.png", color: "#543186" },
  [ThaiBank.Ktb]: { label: "Krungthai", file: "KTB.png", color: "#1DA8E6" },
  [ThaiBank.Ktc]: { label: "KTC", file: "KTB.png", color: "#1DA8E6" },
  [ThaiBank.Bbl]: { label: "Bangkok Bank", file: "BBL.png", color: "#29449D" },
  [ThaiBank.Bay]: { label: "Krungsri", file: "BAY.png", color: "#FFD51C" },
  [ThaiBank.Ttb]: { label: "ttb", file: "TTB.png", color: "#0C55F2" },
  [ThaiBank.Uob]: { label: "UOB", file: "UOB.png", color: "#E41A26" },
  [ThaiBank.Gsb]: { label: "GSB", file: "GSB.png", color: "#ED1891" },
  [ThaiBank.Ghb]: { label: "GHB", file: "GHB.png", color: "#FF8614" },
  [ThaiBank.Baac]: { label: "BAAC", file: "BAAC.png", color: "#CCA41C" },
  [ThaiBank.Cimb]: { label: "CIMB Thai", file: "CIMB.png", color: "#BD1325" },
  [ThaiBank.Citi]: { label: "Citibank", file: "CITI.png", color: "#0F3D89" },
  [ThaiBank.Hsbc]: { label: "HSBC", file: "HSBC.png", color: "#FF1518" },
  [ThaiBank.Ibank]: {
    label: "Islamic Bank",
    file: "IBANK.png",
    color: "#164626",
  },
  [ThaiBank.Icbc]: { label: "ICBC", file: "ICBC.png", color: "#CD1511" },
  [ThaiBank.Kkp]: { label: "KKP", file: "KKP.png", color: "#5A547C" },
  [ThaiBank.Lhb]: { label: "LH Bank", file: "LHB.png", color: "#727375" },
  [ThaiBank.Tcrb]: { label: "Thai Credit", file: "TCRB.png", color: "#FF7813" },
  [ThaiBank.Tisco]: { label: "TISCO", file: "TISCO.png", color: "#267CBC" },
  [ThaiBank.TrueMoney]: {
    label: "TrueMoney",
    file: "TrueMoney.png",
    color: "#EE252B",
  },
  [ThaiBank.PromptPay]: {
    label: "PromptPay",
    file: "PromptPay.png",
    color: "#0C4370",
  },
};

export const BANK_OPTIONS = (Object.keys(BANK_LOGOS) as LogoBank[]).map(
  (code) => ({ code, label: BANK_LOGOS[code].label }),
);

export function bankLogoInfo(bank: ThaiBank | null | undefined) {
  return bank && bank !== ThaiBank.None ? BANK_LOGOS[bank] : null;
}

type MarkNetwork = Exclude<CardNetwork, CardNetwork.None>;

interface NetworkInfo {
  label: string;
  /** simple-icons mark; UnionPay isn't in the set, so it renders as text. */
  icon: { path: string; hex: string } | null;
}

export const NETWORKS: Record<MarkNetwork, NetworkInfo> = {
  [CardNetwork.Visa]: { label: "Visa", icon: siVisa },
  [CardNetwork.Mastercard]: { label: "Mastercard", icon: siMastercard },
  [CardNetwork.Jcb]: { label: "JCB", icon: siJcb },
  [CardNetwork.Amex]: { label: "American Express", icon: siAmericanexpress },
  [CardNetwork.UnionPay]: { label: "UnionPay", icon: null },
};

export const NETWORK_OPTIONS = (Object.keys(NETWORKS) as MarkNetwork[]).map(
  (code) => ({ code, label: NETWORKS[code].label }),
);

export function networkInfo(network: CardNetwork | null | undefined) {
  return network && network !== CardNetwork.None ? NETWORKS[network] : null;
}
